// Thin GA4 wrapper. Safely no-ops if gtag isn't loaded (e.g. blocked by an ad-blocker).
export function trackEvent(name, params = {}) {
  try {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", name, params);
    }
  } catch (e) {
    /* never let analytics break the app */
  }
}
